module.exports = __webpack_public_path__ + "img/bg06.1cb69b2c.gif";